'use client';
import React, { useRef } from 'react';
import cx from 'classnames';
import { Toast } from '../Toast/Toast';
import { useToaster } from './useToaster';
import styles from '../Toast.shared.module.scss';
export const Toaster = (props) => {
    const toasterRef = useRef(null);
    const { toasterContainerProps, toasterProps, toasts } = useToaster(props, { toasterRef });
    return (<div className={cx(styles.toasterContainer, {
            [styles.hasToasts]: toasts.length > 0,
        })} {...toasterContainerProps}>
			<ol ref={toasterRef} className={styles.toaster} {...toasterProps}>
				{toasts.map((toast) => (<Toast key={toast.__internal?.toastId} {...toast}/>))}
			</ol>
		</div>);
};
